import { Injectable } from "@angular/core";
import { LoadingController } from "@ionic/angular";

/**
 * El loading de la app, uno solo a la vez.
 *
 * Corrección del 04/10 (SPEC §3.11.35): `show()` y `hide()` muy seguidos se
 * pisaban. `hide()` cerraba con `getTop()` el loading que estuviera arriba, que
 * podía ser uno ya cerrándose, y el recién creado quedaba abierto para siempre
 * (la pantalla gris con el spinner en Índices). Ahora cada `show()` guarda SU
 * loading y lleva un número de serie: `hide()` cierra ese, y un `show()` que
 * fue cancelado antes de terminar de crearse no llega a presentarse.
 */
@Injectable({ providedIn: "root" })
export class LoaderProvider {
	isLoading = false;
	private actual: HTMLIonLoadingElement | null = null;
	private serie = 0;

	constructor(public loadingCtrl: LoadingController) {}

	async show(message = "") {
		if (this.isLoading) {
			return;
		}
		this.isLoading = true;
		const id = ++this.serie;
		const a = await this.loadingCtrl.create({
			spinner: "crescent",
			showBackdrop: true,
			message: message,
		});
		// hide() llegó mientras se creaba: no se presenta.
		if (!this.isLoading || id !== this.serie) {
			return;
		}
		this.actual = a;
		await a.present();
		if (!this.isLoading || id !== this.serie) {
			if (this.actual === a) this.actual = null;
			await a.dismiss().catch(() => {});
		}
	}

	async hide() {
		if (!this.isLoading) {
			return;
		}
		this.isLoading = false;
		this.serie++;
		const a = this.actual;
		this.actual = null;
		if (a) {
			await a.dismiss().catch(() => {});
			return;
		}
		// Un loading presentado por otro camino: el de arriba.
		const top = await this.loadingCtrl.getTop();
		if (top) await top.dismiss().catch(() => {});
	}
}
